import { render, staticRenderFns } from "./user_group_table.vue?vue&type=template&id=926e4298"
import script from "./user_group_table.vue?vue&type=script&lang=js"
export * from "./user_group_table.vue?vue&type=script&lang=js"


/* normalize component */
import normalizer from "!../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports